import styled from '@emotion/styled'

export const StyleFormWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 500px;
  gap: 5px;
  padding: 20px 30px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
  }
`

export const StyleFormLeftContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #f5f3ff;
  border-radius: 10px;
  padding: 30px;
  gap: 12px;

  @media (max-width: 768px) {
    border-radius: 10px 10px 0 0;
  }
`

export const StyleFormRightWrapper = styled.div`
  background-color: #f1fafb;
  flex: 2;
  border-radius: 10px;
  padding: 30px;

  @media (max-width: 768px) {
    border-radius: 0 0 10px 10px;
  }
`

export const StyleFormFieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 15px;
`

export const IconWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 20px;
`

export const StyleFormFieldWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 30px;
  & > :nth-last-child(-n + 2) {
    grid-column: span 2;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;

    & > * {
      grid-column: span 1 !important;
    }
  }
`

export const StyleInputField = styled.input`
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
  background-color: #fff;

  &:focus {
    outline: none;
    border-color: #262f77;
    box-shadow: 0 0 0 2px rgba(38, 47, 119, 0.2);
  }

  &::placeholder {
    color: #b9b9b9;
    font-size: 12px;
  }
`

export const StyleTextArea = styled.textarea`
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
  resize: vertical;
  min-height: 120px;
  background-color: #fff;

  &:focus {
    outline: none;
    border-color: #262f77;
    box-shadow: 0 0 0 2px rgba(38, 47, 119, 0.2);
  }

  &::placeholder {
    color: #b9b9b9;
    font-size: 12px;
  }
`

export const StyleLabel = styled.label`
  font-size: 14px;
  color: #414146;
  font-weight: 500;
`
